const TAB_SELECTOR = '[data-tabs-tab]';
const PANEL_SELECTOR = '[data-tabs-content]';
const SECTION_SELECTOR = '[data-tabs-section]';

const updateActiveSwiper = panelEl => {
  const swiperEl = panelEl.querySelector('[data-swiper]');
  if (!swiperEl?.swiper) return;

  requestAnimationFrame(() => swiperEl.swiper.update());
};

const activateTab = (sectionEl, activeTabId) => {
  const tabs = sectionEl.querySelectorAll(TAB_SELECTOR);
  const panels = sectionEl.querySelectorAll(PANEL_SELECTOR);

  tabs.forEach(tabEl => {
    const isActive = tabEl.dataset.tabsTab === activeTabId;
    tabEl.setAttribute('aria-selected', isActive.toString());
    tabEl.tabIndex = isActive ? 0 : -1;
  });

  panels.forEach(panelEl => {
    const isActive = panelEl.dataset.tabsContent === activeTabId;
    panelEl.hidden = !isActive;
    if (isActive) updateActiveSwiper(panelEl);
  });
};

const handleTabClick = event => {
  const tabEl = event.currentTarget;
  const sectionEl = tabEl.closest(SECTION_SELECTOR);
  if (!sectionEl) return;

  activateTab(sectionEl, tabEl.dataset.tabsTab);
};

const handleTabKeydown = event => {
  const sectionEl = event.currentTarget.closest(SECTION_SELECTOR);
  if (!sectionEl) return;

  const tabs = [...sectionEl.querySelectorAll(TAB_SELECTOR)];
  const currentIndex = tabs.indexOf(event.currentTarget);
  let targetIndex;

  switch (event.key) {
    case 'ArrowRight':
      targetIndex = (currentIndex + 1) % tabs.length;
      break;
    case 'ArrowLeft':
      targetIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      break;
    case 'Home':
      targetIndex = 0;
      break;
    case 'End':
      targetIndex = tabs.length - 1;
      break;
    default:
      return;
  }

  event.preventDefault();
  const targetTabEl = tabs[targetIndex];
  activateTab(sectionEl, targetTabEl.dataset.tabsTab);
  targetTabEl.focus();
};

const handleBlockSelect = event => {
  const panelEl = event.target.closest(PANEL_SELECTOR);
  if (!panelEl) return;

  const sectionEl = panelEl.closest(SECTION_SELECTOR);
  if (!sectionEl) return;

  activateTab(sectionEl, panelEl.dataset.tabsContent);
};

const initTabs = () => {
  const sections = document.querySelectorAll(`${SECTION_SELECTOR}:not([data-tabs-initialized])`);

  sections.forEach(sectionEl => {
    const tabs = sectionEl.querySelectorAll(TAB_SELECTOR);
    if (!tabs.length) return;

    tabs.forEach(tabEl => {
      tabEl.addEventListener('click', handleTabClick);
      tabEl.addEventListener('keydown', handleTabKeydown);
    });
    sectionEl.addEventListener('shopify:block:select', handleBlockSelect);

    sectionEl.dataset.tabsInitialized = 'true';
  });
};

export default initTabs;
